<template>
    <div class="row">
        <div class="col-md-4">
            <div class="form-group">
                <label>{{ $t('general.codigo') }}</label>
                <input v-model="siniestro.codigo_original" @input="serviciomodificado['codigo_original']=1" type="text" class="form-control input-sm" placeholder="Codigo">
            </div>
        </div>
        <div class="col-md-4">
            <div class="form-group">
                <label>{{ $t('general.naviso') }}</label>
                <input v-model="siniestro.n_aviso" @input="serviciomodificado['n_aviso']=1" type="text" class="form-control input-sm" placeholder="Aviso">
            </div>
        </div>
        <div class="col-md-4">
            <div class="form-group">
                <label>{{ $t('general.anyodelsiniestro') }}</label>
                <input v-model="siniestroaux.anno_servicio" @input="serviciomodificado['anno_servicio']=1" type="text" class="form-control input-sm" placeholder="Codigo">
            </div>
        </div>
        <div class="col-md-12" v-if="empresas">
            <div class="form-group">
                <label>{{ $t('general.empresafactura') }}</label>
                <select v-model="selected_empresa" @change="serviciomodificado['empresa']=1" id="" class="form-control">
                    <option v-for="empresa in empresas" :key="empresa.id" :value="empresa">{{ empresa.nombre_empresa }}</option>
                </select>
            </div>
        </div>
        <div class="col-md-12">
            <div class="form-group">
                <label>{{ $t('general.compania') }}</label>
                <select v-model="selected_companyia" @change="serviciomodificado['companyia']=1" class="form-control">
                    <option v-for="companyia in listadocompanyias" :key="companyia.id" :value="companyia.id">{{ companyia.nombre+' ('+companyia.prefijo+')' }} </option>
                </select>
            </div>
        </div>
        <div class="col-md-12" v-if="listadocorredurias">
            <div class="form-group">
                <label>{{ $t('general.companiacorreduria') }}</label>
                <select v-model="selected_correduria" @change="serviciomodificado['correduria']=1" class="form-control">
                    <option v-for="correduria in listadocorredurias" :key="correduria.id" :value="correduria.id">{{ correduria.nombre }}</option>
                </select>
            </div>
        </div>
        <div class="col-md-12" v-if="listadocompanyiasseguro">
            <div class="form-group">
                <label>{{ $t('general.contrato') }}</label>
                <v-select v-model="selected_companyia_seguros" @input="serviciomodificado['companyia_seguros']=1" :options="listadocompanyiasseguro"></v-select>
                <input v-model="companiaSegurosInput" type="text" class="form-control input-sm">
            </div>
        </div>
        <div class="col-md-12" v-if="listadocompanyiasseguro2">
            <div class="form-group">
                <label>{{ $t('general.companiadeseguros') }}</label>
                <select class="form-control" @change="serviciomodificado['companyia_seguros2']=1" v-model="selected_companyia_seguros2">
                    <option v-for="companyia in listadocompanyiasseguro2" :key="companyia.id_companyia_asitur" :value="companyia.id_companyia_asitur">{{ companyia.nombre }}</option>
                </select>
            </div>
        </div>
        <div style="margin: 0;" v-if="pap" class="row">
            <div class="col-md-4">
                <div class="form-group">
                    <label for="idcompania">Id Compañía:</label>
                    <input v-model="idcompania" @input="serviciomodificado['idcompania']=1" type="text" class="form-control input-sm">
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label for="idcompania">Id Ramo:</label>
                    <input v-model="idramo" @input="serviciomodificado['idramo']=1" type="text" class="form-control input-sm">
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label for="idcompania">Id Interviniente:</label>
                    <input v-model="idinterviniente" @input="serviciomodificado['idinterviniente']=1" type="text" class="form-control input-sm">
                </div>
            </div>
        </div>
        <div class="col-md-6" v-if="asitur">
            <div class="form-group">
                <label>{{ $t('general.referencia') }}</label>
                <input v-model="siniestroaux.referencia_companyia_asitur_servicio" @input="serviciomodificado['referencia_companyia_asitur_servicio']=1" type="text" class="form-control input-sm">
            </div>
        </div>
        <div class="col-md-12">
            <div class="form-group">
                <label >{{ $t('general.danyos') }}</label>
                <textarea v-model="siniestroaux.daños" @input="serviciomodificado['danos']=1" class="form-control"></textarea>
            </div>  
        </div>
        <div class="col-md-12">
            <div class="form-group">
                <label >{{ $t('general.notaimportante') }}</label>
                <textarea v-model="siniestroaux.nota_importante" @input="serviciomodificado['nota_importante']=1" class="form-control"></textarea>
            </div>  
        </div>
        <div class="col-md-12">
            <div class="form-group">
                <label >{{ $t('general.observaciones') }}</label>
                <textarea v-model="siniestroaux.observaciones" @input="serviciomodificado['observaciones']=1" class="form-control"></textarea>
            </div>  
        </div>
        <!--<div class="col-md-12">
            <div class="form-group">
                <label >{{ $t('general.viptexto') }}</label>      
            </div>  
        </div>-->
    </div>            
</template>
<script>
import { PwgsApi } from '../../../../../services/PwgsApi';

export default ({
    props:['servicio','id','guardartoken', 'servicioext'],
    setup() {
        return;
    },
    data() {
        return {
            serviciomodificado:[],
            selected_companyia_seguros:'',
            selected_companyia_seguros2:'',
            selected_companyia: '',
            selected_correduria:'',
            selected_empresa: '',
            siniestro: '',
            companyias:'',
            listadocompanyiasseguro:[],
            listadocompanyiasseguro2:[],
            listadocompanyias: [],
            listadocorredurias:[],
            siniestroaux: [],
            listaempresas: [],
            empresas: [],
            pap:false,
            asitur:false,
            idcompania:'',
            idinterviniente:'',
            idramo:'',
            companiaSegurosInput:'',
            primero:true,
        }
    },
    methods: {
        async listadocompanias() {
            //get  modulos/pwgsapi/index.php/companias/simple
            const api = new PwgsApi;
            const datos = await api.get("companias/simple");
            this.companyias = datos.datos;
            this.listadocompanyias = datos.datos;            
        },
        async listadocompaniasseguros() {
            //get  modulos/pwgsapi/index.php/companias/simple
            const api = new PwgsApi;
            this.listadocompanyiasseguro = await api.get("companias/"+this.$props.servicio.compania.id+"/contratos-servicios");    
            var resp = await api.get("companias/"+this.$props.servicio.compania.id+"/companias-seguros");
            this.listadocompanyiasseguro2 = resp.datos;
        },
        async listadocompaniasseguroscambio(nuevo) {
            //get  modulos/pwgsapi/index.php/companias/simple
            const api = new PwgsApi;
            this.listadocompanyiasseguro = await api.get("companias/"+nuevo+"/contratos-servicios");
            var resp = await api.get("companias/"+nuevo+"/companias-seguros");
            this.listadocompanyiasseguro2 = resp.datos;
            if(this.primero){
                this.primero = false;
            }else{
                this.selected_companyia_seguros2 = '';
                this.companiaSegurosInput = '';
                this.selected_companyia_seguros = '';
            }
        },
        async cargarlistadocorredurias() {
            //get  modulos/pwgsapi/index.php/companias/"+this.$props.servicio.compania.id+"/companias-correduria
            const api = new PwgsApi;
            const datos = await api.get("companias/"+this.$props.servicio.compania.id+"/companias-correduria");
            this.listadocorredurias = datos.datos;
        },
        async listadoempresas() {
            //GET  modulos/pwgsapi/index.php/empresas/simple
            const api = new PwgsApi;
            this.empresas = await api.get("empresas/todas");
            let idempresa = this.servicioext.datos.empresas_factura_id_empresa;
            this.selected_empresa = this.empresas.find(empresa => empresa.id == idempresa);
        },
        async cargarservicio() {
            //get  modulos/pwgsapi/index.php/servicios/:idq
            const api = new PwgsApi;
            const datos = await api.get("servicios/" + this.$props.id);
            this.siniestroaux = datos.datos;
            this.selected_companyia_seguros = this.siniestroaux.companyia_seguros_servicio;
            this.selected_companyia_seguros2 = this.siniestroaux.id_companyia_asitur;
            this.selected_correduria = this.siniestroaux.id_correduria;
        },
        async guardarsiniestro() {
            //put  modulos/pwgsapi/index.php/servicios/:id/modificar-servicio
            // selected_companyia, siniestroaux.companyia_seguros_servicio ,
            try {
                const api = new PwgsApi;
                let subidadatos = {};
                if (this.pap) {
                    
                if(this.serviciomodificado['idinterviniente']==1){subidadatos.pap_interviniente = this.idinterviniente}
                if(this.serviciomodificado['idcompania']==1){subidadatos.pap_compania = this.idcompania}
                if(this.serviciomodificado['idramo']==1){subidadatos.pap_ramo = this.idramo}
                // subidadatos.urgente = this.siniestro.urgente;
                if(this.serviciomodificado['codigo_original']==1){subidadatos.codigo = this.siniestro.codigo_original}
                if(this.serviciomodificado['n_aviso']==1){subidadatos.n_aviso = this.siniestro.n_aviso}
                if(this.serviciomodificado['referencia_companyia_asitur_servicio']==1){subidadatos.asitur_referencia =this.siniestroaux.referencia_companyia_asitur_servicio}
                if(this.serviciomodificado['anno_servicio']==1){subidadatos.pap_year = this.siniestroaux.anno_servicio}
                if(this.serviciomodificado['danos']==1){subidadatos.danos = this.siniestroaux.daños}
                if(this.serviciomodificado['observaciones']==1){subidadatos.observaciones = this.siniestroaux.observaciones}
                if(this.serviciomodificado['nota_importante']==1){subidadatos.nota_importante = this.siniestroaux.nota_importante}
                if(this.serviciomodificado['empresa']==1){subidadatos.id_empresa = this.selected_empresa.id}
                if(this.serviciomodificado['companyia']==1){subidadatos.id_compania = this.selected_companyia}
                if(this.serviciomodificado['companyia_seguros']==1){subidadatos.id_compania_seguro = this.companiaSegurosInput}
                if(this.serviciomodificado['companyia_seguros2']==1){subidadatos.asitur_compania = this.selected_companyia_seguros2}
                if(this.serviciomodificado['correduria']==1){subidadatos.id_correduria = this.selected_correduria}
                    
                } else {
                                  
                //subidadatos.urgente = this.siniestro.urgente;
                if(this.serviciomodificado['codigo_original']==1){subidadatos.codigo = this.siniestro.codigo_original}
                if(this.serviciomodificado['n_aviso']==1){subidadatos.n_aviso = this.siniestro.n_aviso}
                if(this.serviciomodificado['referencia_companyia_asitur_servicio']==1){subidadatos.asitur_referencia =this.siniestroaux.referencia_companyia_asitur_servicio}
                if(this.serviciomodificado['anno_servicio']==1){subidadatos.pap_year = this.siniestroaux.anno_servicio}
                if(this.serviciomodificado['danos']==1){subidadatos.danos = this.siniestroaux.daños}
                if(this.serviciomodificado['observaciones']==1){subidadatos.observaciones = this.siniestroaux.observaciones}
                if(this.serviciomodificado['nota_importante']==1){subidadatos.nota_importante = this.siniestroaux.nota_importante}
                if(this.serviciomodificado['empresa']==1){subidadatos.id_empresa = this.selected_empresa.id}
                if(this.serviciomodificado['companyia']==1){subidadatos.id_compania = this.selected_companyia}
                if(this.serviciomodificado['companyia_seguros']==1){subidadatos.id_compania_seguro = this.companiaSegurosInput}
                if(this.serviciomodificado['companyia_seguros2']==1){subidadatos.asitur_compania = this.selected_companyia_seguros2}
                if(this.serviciomodificado['correduria']==1){subidadatos.id_correduria = this.selected_correduria}
                }
                await api.put('servicios/' + this.$props.id + '/modificar-servicio', subidadatos);
                this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Datos guardados correctamente', life: 2000 });
            }
            catch (error) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
            }
            localStorage.setItem('nombreservicio' + this.$props.id, this.siniestro.codigo);
            let aux = document.getElementById('ruta' + this.$props.id);
            console.log("prueba123", aux);
            console.log("parent", this.$parent);
            this.$parent.$parent.$parent.cargardatos(this.$props.id,"cual","si");
            this.$parent.$parent.$parent.cargarmasdatos(this.$props.id, "cual", "si");

            setTimeout(() => {
                console.log("codigo", this.siniestro.codigo);
                document.getElementById('ruta' + this.$props.id).innerHTML = "Servicio: " + this.$props.servicio.codigo;
                

            }, 2000);
            this.serviciomodificado = [];
            this.$emit('ver');

        },
        comprobarPap(){
            if(this.servicio.compania.sistema == 'P.A.P.'){
                this.pap = true;
                this.idcompania = this.servicioext.datos.compannia_servicio;
                this.idramo = this.servicioext.datos.ramo_servicio;
                this.idinterviniente = this.servicioext.datos.pap_interviniente;
            }
        },
        comprobarAsitur(){
            if(this.servicio.compania.sistema == 'ASITUR'){
                this.asitur = true;
            }
        }
    },
    mounted() {
        this.comprobarPap();
        this.comprobarAsitur();
        this.cargarservicio();
        this.listadocompanias();
        this.listadoempresas();
        this.listadocompaniasseguros();
        this.cargarlistadocorredurias();
        this.siniestro = this.$props.servicio;
        this.selected_companyia = this.$props.servicio?.compania?.id;
    },
    watch: {
        selected_companyia_seguros(valor){
            this.companiaSegurosInput = valor;
        },
        selected_companyia(valor){
            this.listadocompaniasseguroscambio(valor);
        },
        id() {
            this.cargarservicio();
            this.listadocompanias();
            this.listadoempresas();
            this.listadocompaniasseguros();
            this.cargarlistadocorredurias();
            this.siniestro = this.$props.servicio;
            this.selected_companyia = this.$props.servicio?.compania?.id;
            this.selected_correduria = this.$props.servicio?.correduria?.id;
        },
        guardartoken() {
            this.guardarsiniestro();
            //this.cargarservicio();
            this.$parent.$parent.$parent.cargardatos(this.$props.id);
        },
    }
})
</script>